import { useLocaleContext } from '../LocaleLogicProvider'

export default function useGetProductOrKitByLocale({ slug }) {
  const { productsAndKitsByLocale = [] } = useLocaleContext()

  return productsAndKitsByLocale.find(item => item.slug === slug) || {}
}
